import React from 'react';

import ScrollToTop from '../components/ScrollToTop';
import Intro from '../components/Intro';
import CTA from '../components/CTA';
import RegularBlock from '../components/RegularBlock';
import SocialBlock from '../components/SocialBlock';
import SEO from '../components/SEO';

import { workWithUsData } from '../static/data';

function WorkWithUs() {
  let { intro, regularBlocks } = workWithUsData;
  return (
    <>
      <SEO
        title="WE3 Academy | Mentor Volunteer Partner | Work With Us"
        description="We are creating a community of passionate developers, designers, and entrepreneurs. Come be a part of WE3 Academy. Help us build a better education and bridge the gap between education and empower students to be able to create amazing products."
        keywords="WE3 Academy, WE3, instructor, mentors, mentorship, web development instructor, web developer, full stack web developer, full stack developer, social media marketer, career counselor, career facilitator, social media instructor, social media professional, dev community, developers, tech bootcamp, programmer, coder, educator, lecturer, career coach, career adviser, trainer, trainers, tutor"
        link="/work-with-us"
      />
      <section id="workWithUs">
        <ScrollToTop />
        <Intro sectionId="workWithUsIntro" intro={intro} />
        {regularBlocks &&
          regularBlocks.length > 0 &&
          regularBlocks.map((block, blockId) => (
            <RegularBlock key={blockId} data={block} {...block} />
          ))}
        <SocialBlock styleType="style1" />
        <CTA styleType="style7" />
      </section>
    </>
  );
}

export default WorkWithUs;
